import * as S from './styles';
import { Car } from 'lucide-react';
import Fontes from './fonts/Fontes.js';

function EscolherPagamento({ valores, onSelecionar }) {
  return (
    <S.VehicleList>
      {!!valores.valores && valores.valores.length > 0 && (
          valores.valores.map((item, index) => (
            <S.VehicleCard
              key={index}
              onClick={() => {
                onSelecionar(item.pagamentos[0]);
              }}><S.VehicleCardItem><S.BoxTipo color={!!item.legenda_cor_primaria ? item.legenda_cor_primaria : 'black'} >
<Fontes.IconFont
            icone={!!item.icone ? item.icone : "FontAwesome:car"}
            size={32}
            color={!!item.legenda_cor_secundaria ? item.legenda_cor_secundaria : 'white'}
          /></S.BoxTipo></S.VehicleCardItem>

              <S.VehicleCardItemG>
              <S.Texto3>{item.legenda_descricao}</S.Texto3>
              <S.Texto2>{item.legenda_explicacao}</S.Texto2></S.VehicleCardItemG>
              <S.VehicleCardItem>
              {item.pagamentos.map((pag, idx) => (
                <S.Texto4 key={idx}>R$ {pag.valor_final.toFixed(2)}</S.Texto4>
              ))}</S.VehicleCardItem>
            </S.VehicleCard>
          ))
      )}
    </S.VehicleList>
  );
}
export default EscolherPagamento;
